import { AnalyticsMetaKeys as key } from '../../../../../../services/analytics/formatters/meta-keys'
import { IdentityEvent } from '../../../../../../services/common/events/identity'
import { AnalyticsEvent } from '../../../../event'
import { AttributeFormatter } from '../../formatters/attribute'
import { PageEvents } from '../../page-events'

const mParticleEvents: any = new PageEvents()

export class ScreenView extends AnalyticsEvent {

    public attributeFormatter = new AttributeFormatter()
    /**
     * Handle a view page load event
     */
    public handle(): void {

        /**
         * @var attrs will be different for each
         * events
         *
         * there are events which has will have attributes
         * both from dom element and page meta properties
         */
        const attrs = [
            key.DOMAIN,
            key.PAGE_RES_TYPE,
            key.VID_IN_PAGE,
            key.AD_LIGHT,
            key.REF_DETAILS,
            key.TITLE,
            key.TYPE,
            key.GLOBAL_ID,
            key.CANONICAL_PATH,
            key.CATEGORY,
            key.ARTICLE_ID,
            key.ORIGINAL_ID,
            key.VERSION,
            key.ALL_SUB_SEC,
            key.SUB_SEC,
            key.SUB_SEC_2,
            key.SUB_SEC_3,
            key.MAIN_CATEGORY,
            key.DISTRIBUTOR,
            key.KLNGO_ENTITY,
            key.KLNGO_CATEGORY,
            key.NLP_ENTITY,
            key.NLP_TOPIC,
            key.DIVISION,
            key.BRAND,
            key.WRITERS,
            key.BYLINE,
            key.WIRE_AUTHORS,
            key.IS_WIRE,
            key.PAYWALL,
            key.METERED_CONTENT_TYPE,
            key.META_TAG,
            key.PAGE_RES_TIME,
            key.PUB_DATE,
            key.PUB_TIME,
            key.WRD_CNT,
            key.SLUG,
            key.DEBUG,
            key.CUR_PAGE,
            key.IS_ORIGINAL,
            key.VENDOR,
            key.USER_LOGGEDIN,
            key.PROJECT_TYPE
        ]

        const data = this.attributeFormatter.format(attrs, this.metaProperties)

        addEventListener(IdentityEvent.MP_READY, (e: any) => {
            if (e.detail.mpSessionUuid) {
                mParticleEvents.logPageView(
                    PageEvents.mpEventName.ScreenView,
                    {
                        ...data,
                        ...{[key.SESSION_UUID]: String(e.detail.mpSessionUuid)},
                        ...{[key.MP_ID]: String(e.detail.mpId)}
                    },
                    {}
                )
            } else {
                mParticleEvents.logPageView(
                    PageEvents.mpEventName.ScreenView,
                    data,
                    {}
                )
            }
        })
    }
}
